import { useId } from 'react'
import PropTypes from 'prop-types'
import { pinsVariantComponentOptions, pinsVariantOptions } from '../constants'
import { PinContainer, Pin } from '../styled-components'

const PinBase = ({
  variant,
  size = 32,
  children,
  counter,
  colorCounter = 'white',
  isInactive = false,
  scale = 9.5,
  translate = '2.75, 2',
  gradientId: gradientIdProp,
  ...props
}) => {
  
  const generatedId = useId()
  const gradientId = gradientIdProp || generatedId
  const defineVariant = counter ? 'gradient-gray' : variant
  const { fill, gradientColor } = pinsVariantComponentOptions[defineVariant]

  const isGradient = variant.includes('gradient')

  const defineFill = isGradient ? `url(#${gradientId})` : fill

  return (
    <PinContainer {...props}>
      <Pin>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={size}
          height={size}
          viewBox="0 0 17 24"
          fill="none"
          opacity={isInactive ? 0.5 : 1}
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.43335 0C4.01455 0 0.43335 3.348 0.43335 7.47839C0.43335 12.8836 8.43335 24 8.43335 24C8.43335 24 16.4333 12.8836 16.4333 7.47839C16.4333 3.348 12.8505 0 8.43335 0"
            fill={defineFill}
          />
          <defs>
            <linearGradient
              id={gradientId}
              x1="4.30875"
              y1="1.06849"
              x2="15.2695"
              y2="20.053"
              gradientUnits="userSpaceOnUse"
            >
              {gradientColor}
            </linearGradient>
          </defs>
          {counter ? (
            <text
              x="50%"
              y="35%"
              textAnchor="middle"
              fill={colorCounter}
              fontSize="5.5"
              dy=".3em"
              fontWeight="bold"
            >
              {counter}
            </text>
          ) : (
            <g transform={`translate(${translate}) scale(${scale / 100})`}>
              {children}
            </g>
          )}
        </svg>
        {isGradient && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size / 2}
            height={size / 2}
            viewBox="0 0 17 8"
            fill="none"
            style={{
              position: 'absolute',
              top: size / 1.3,
              left: size / 4
            }}
          >
            <g style={{ mixBlendMode: 'multiply' }}>
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.76672 8C13.185 8 16.7667 6.20914 16.7667 4C16.7667 1.79086 13.185 0 8.76672 0C4.34845 0 0.766724 1.79086 0.766724 4C0.766724 6.20914 4.34845 8 8.76672 8Z"
                fill={`url(#${gradientId}_shadow)`}
              />
            </g>
            <defs>
              <radialGradient
                id={`${gradientId}_shadow`}
                cx="0"
                cy="0"
                r="1"
                gradientUnits="userSpaceOnUse"
                gradientTransform="translate(8.76672 4) scale(7.6 3.70733)"
              >
                <stop stopColor="#141A21" stopOpacity="0.25098" />
                <stop offset="1" stopColor="white" stopOpacity="0" />
              </radialGradient>
            </defs>
          </svg>
        )}
      </Pin>
    </PinContainer>
  )
}

PinBase.propTypes = {
  variant: PropTypes.oneOf(Object.values(pinsVariantOptions)),
  size: PropTypes.number,
  children: PropTypes.node,
  counter: PropTypes.number,
  colorCounter: PropTypes.string,
  isInactive: PropTypes.bool,
  scale: PropTypes.number,
  translate: PropTypes.string
}

export default PinBase
